import { DefaultValues } from "react-hook-form";
import * as yup from "yup";
import { AI_SUPPORT_DRAFT_MAX_CONTENT, aiAssistantTexts } from "./aiAssistantModels";

/** The ticket text the user may edit before "Изпрати към екипа". */
export const aiSupportDraftFormSchema = yup
  .object({
    content: yup
      .string()
      .trim()
      .required(aiAssistantTexts.draftContentRequired)
      .max(AI_SUPPORT_DRAFT_MAX_CONTENT, aiAssistantTexts.draftContentTooLong(AI_SUPPORT_DRAFT_MAX_CONTENT))
      .defined(),
  })
  .required();

export type IAiSupportDraftFormModel = yup.InferType<typeof aiSupportDraftFormSchema>;

export const getAiSupportDraftFormDefaultValues = (content: string): DefaultValues<IAiSupportDraftFormModel> => ({
  content,
});
